<template>
  <div class="union" style="min-width:1440px;">
    <div class="second_banner" >
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <img class="banner_img" :src="img.data.data.url" alt />
    </div>
    <div class="second_main animated fadeInUp" style="padding-left:20%;padding-right:20%">
      <div > 
        <el-tabs tab-position="left" v-model="name" >
          <el-tab-pane name="1" :label="chOrEn=='1'?'联盟介绍':'Introduction to ISPU'">
            <span slot="label">
              <i class="el-icon-caret-right" v-if="name=='1'"></i>
              <span style="font-size:14px;font-weight: bold;" v-if="chOrEn=='1'">联盟介绍</span>
              <span style="font-size:14px;font-weight: bold;" v-else>Introduction to ISPU</span>
              <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
            </span>
            <div class="info">
              <div style="text-align:left" v-html="listOne.content">{{listOne.content}}</div>
              <!-- <p>2014年9月，雕塑公园国际联盟由长春世界雕塑园等5个单位共同发起成立，并于2016年第一次联盟全体大会后，研究更名为雕塑园(馆)国际联盟。联盟于2018年6月25日在瑞士注册成功，目前成员为来自世界10个国家和地区的23个成员单位。联盟第一任主席由长春世界雕塑园园长王明山担任，联盟第二任主席，即现任主席由圣·乌尔班雕塑公园发起人格楚·艾希曼担任。</p>
              <div class="info_img_box">
                <div class="img_item">
                  <img src="../assets/img/proposal1.png" alt />
                </div>
                <div class="img_item">
                  <img src="../assets/img/proposal2.png" alt />
                </div>
              </div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane name="2" :label="chOrEn=='1'?'联盟秘书处':'Union Secretariat'">
            <span slot="label">
              <i class="el-icon-caret-right" v-if="name=='2'"></i>
              <span style="font-size:14px;font-weight: bold;" v-if="chOrEn=='1'">联盟秘书处</span>
              <span style="font-size:14px;font-weight: bold;" v-else>Union Secretariat</span>
              <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
            </span>
            <div class="mechanism">
              <p v-html="listTwo.content">{{listTwo.content}}</p>
              <!-- <p>长春世界雕塑园位于长春市核心区，占地面积92公顷，其中水域面积11.8公顷，是集自然山水与人文景观于一体现代城市雕塑主题景区，国家AAAAA级景区, 首批“国家重点公园”,首批“创造未来文化遗产”示范单位，并获得了“新中国城市雕塑建设成就奖”中唯一一个"雕塑公园成就奖"。</p>
              <p>景区始建于2000年，2003年9月5日正式对外开放。通过长春国际雕塑作品邀请展等大型活动，园内汇集了来自五大洲216个国家和地区的10021件（组）雕塑、绘画等艺术作品，其中雕塑8337件（组）、绘画1676幅、书法8幅。它们材质丰富、风格迥异，充分体现了公园的主题“友谊·和平·春天。”</p>
              <p>景区目前是“一园五馆”的格局，长春雕塑艺术馆、松山韩荣非洲艺术收藏博物馆、魏小明艺术馆、雕塑体验馆和长春雕塑博物馆，五大展馆充分展现了雕塑艺术与建筑艺术的完美融合，造型独特，内涵丰富，广受赞誉。</p>
              <p>这里是举办各类大型活动的重要场地，也是群众休闲养生的艺术养吧；是国内十几家顶级高校的教学实践基地，也是群众了解雕塑艺术的主要场所；是世界雕塑艺术交流的圣地，更是长春的一张金色名片！</p>
              <p>长春世界雕塑园，四季的露天雕塑博物馆，欢迎您的到来！</p>
              <div class="one_img">
                <img src="../assets/img/mechanism1.png" alt />
              </div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane name="3" :label="chOrEn=='1'?'联盟大事件':'Union Events'">
            <span slot="label">
              <i class="el-icon-caret-right" v-if="name=='3'"></i>
              <span style="font-size:14px;font-weight: bold;" v-if="chOrEn=='1'">联盟大事件</span>
              <span style="font-size:14px;font-weight: bold;" v-else>Union Events</span>
              <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
            </span>
            <div class="big_event">
              <p v-html="listThree.content">{{listThree.content}}</p>
              <!-- <h2>联盟时间轴</h2>
              <ul class="time_list">
                <li class="time_item">
                  <div class="time_item_title">2020年</div>
                  <span class="time_item_des">开通联盟网站。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2019年</div>
                  <span class="time_item_des">筹备联盟瑞士工作会议。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2018年</div>
                  <span class="time_item_des">联盟在瑞士注册成功。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2017年</div>
                  <span class="time_item_des">第五届中国长春世界雕塑大会期间同步召开第二次联盟工作会议。</span>
                  <span>雕塑园（馆）国际联盟展览馆开馆。</span>
                  <span>开展联盟注册工作，委托瑞士全权办理联盟的注册工作。</span>
                  <span>修订联盟章程。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2016年</div>
                  <span class="time_item_des">召开第一次联盟全体大会和“共话雕塑公园的未来”主题研讨会。</span>
                  <span>联盟主席换届，瑞士圣·乌尔班雕塑园格楚女士任主席。</span>
                  <span>组织更名为雕塑园（馆）国际联盟。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2015年</div>
                  <span class="time_item_des">成立联盟董事会。</span>
                  <span>联盟开展纳新工作。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2014年</div>
                  <span
                    class="time_item_des"
                  >第四届中国长春世界雕塑大会召开期间，由中国长春世界雕塑园、瑞士圣·乌尔班雕塑公园、意大利基安蒂雕塑公园、法国贝丁顿雕塑花园、拉脱维亚佩德维尔露天雕塑博物馆共同发起的雕塑公园国际联盟正式成立。长春世界雕塑园王明山先生任联盟主席，会议起草了《雕塑公园国际联盟章程》，联盟决定在长春世界雕塑园设立秘书处。</span>
                </li>
                <li class="time_item">
                  <div class="time_item_title">2011年</div>
                  <span
                    class="time_item_des"
                  >联盟发起于第三届中国长春世界雕塑大会。大会组委会在策划各项活动和议程时，专家和领导建议长春世界雕塑园应该组建一个各雕塑公园间的联盟，但因为时间的原因，这个想法在大会上没能实现，但成立雕塑公园国际联盟的各项准备工作由此逐步展开。</span>
                </li>
              </ul> -->
            </div>
          </el-tab-pane>
          <el-tab-pane name="4" :label="chOrEn=='1'?'联盟章程':'Union Constitution'">
            <span slot="label">
              <i class="el-icon-caret-right" v-if="name=='4'"></i>
              <span style="font-size:14px;font-weight: bold;" v-if="chOrEn=='1'">联盟章程</span>
              <span style="font-size:14px;font-weight: bold;" v-else>Union Constitution</span>
              <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
            </span>
            <div class="zhangcheng">
              <p v-html="listFour.content">{{listFour.content}}</p>
              <!-- <h2>联盟章程</h2>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/lianmeng3.png" alt />
                </div>
                <div class="img_box">
                  <img src="../assets/img/lianmeng4.png" alt />
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/lianmeng5.png" alt />
                </div>
                <div class="img_box">
                  <img src="../assets/img/lianmeng6.png" alt />
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/lianmeng7.png" alt />
                </div>
                <div class="img_box">
                  <img src="../assets/img/lianmeng8.png" alt />
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/lianmeng9.png" alt />
                </div>
                <div class="img_box">
                  <img src="../assets/img/lianmeng10.png" alt />
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/lianmeng11.png" alt />
                </div>
                <div class="img_box">
                  <img src="../assets/img/lianmeng12.png" alt />
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/lianmeng13.png" alt />
                </div>
              </div> -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

  </div>
</template>

<script>
import { baseByNav, getByNav } from '../api/api'
export default {
  name: "union",
  data(){
    return{
      chOrEn:sessionStorage.getItem('chOrEn'),
      img:'',
      listOne:'',
      listTwo:'',
      listThree:'',
      listFour:'',
      name:'1',
    }
  },
  created(){
    if(this.$route.query.list){
      this.name=this.$route.query.list
    }
    let navigationId = {
      navigationId:11
    }
    baseByNav({...navigationId}).then(res=>{
      this.listOne = res.data.data
    })
     navigationId = {
      navigationId:12
    }
    baseByNav({...navigationId}).then(res=>{
      this.listTwo = res.data.data
    })
     navigationId = {
      navigationId:13
    }
    baseByNav({...navigationId}).then(res=>{
      this.listThree = res.data.data
    })
     navigationId = {
      navigationId:14
    }
    baseByNav({...navigationId}).then(res=>{
      this.listFour = res.data.data
    })
    let getBynavid = {
      navigationId:2
    }
    getByNav({...getBynavid}).then(res=>{
      this.img = res
    })
  }
  
};
</script>
<style>
  /* #app /deep/ .el-tabs--left .el-tabs__item.is-left {
    font-size: 18px;
  } */
  #app /deep/ .el-tabs--left .el-tabs__item.is-left {
    border-bottom:1px solid #F0F0F0;
    height:70px;
    padding: 15px 20px;
  }
</style>
<style lang="less" scoped>
  /deep/ .el-tabs--left .el-tabs__item.is-left{
      text-align: left;
      font-size:18px
  }
  .banner_img{
    height:400px
  }
.union {
  width:100%;
  .second_main {
    text-align:center;
    .info {
      .info_img_box {
        display: flex;
        justify-content: space-between;
        .img_item {
          width: 400px;
          height: 487px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .big_event {
      h2 {
        font-size: 18px;
        color: #2f2f2f;
        text-align: center;
        font-weight: 800;
        margin-bottom: 40px;
      }
      .time_list {
        .time_item {
          margin-bottom: 10px;
          .time_item_title {
            width: 84px;
            height: 30px;
            line-height: 30px;
            border-bottom: 2px solid #000;
            margin-bottom: 10px;
          }
          span {
            display: block;
            font-size: 14px;
            line-height: 30px;
            color: #606060;
          }
        }
      }
    }
    .zhangcheng{
        h2{
            font-size: 18px;
            color: #2f2f2f;
            text-align: center;
            font-weight: 800;
            margin-bottom: 40px;
        }
        .two_img{
            display: flex;
            justify-content: space-between;
           .img_box{
                width: 400px;
                height: 487px;
                img{
                    width: 100%;
                    height: 100%;
                }
           } 
        }
    }
  }
}
</style>